'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdExposureNeg2 = function MdExposureNeg2(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm3.4 18.4h13.2v3.2h-13.2v-3.2z m24-10c4.1 0 6.7 1.8 6.7 5.8 0 0.6 0 1.3-0.3 2s-0.4 1.3-0.8 1.9c-0.9 1.4-2 2.8-3.2 3.9l-4.7 5.2h9.9v2.8h-14.4v-2.5l7-7.6c1-1 1.7-2 2.4-3.1 0.4-0.7 0.5-1.2 0.5-2.2 0-0.5 0-1-0.1-1.4-0.5-1.2-1.4-2-3-2-2.4 0-3.6 1.4-3.6 3.8h-3.6c0-2 0.8-3.6 1.9-4.7 1.2-1.2 2.9-1.9 5.3-1.9z' })
        )
    );
};

exports.default = MdExposureNeg2;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/exposure-neg-2.js
// module id = 3045
// module chunks = 0